
import Vue from 'vue'
import TransferService from '../transfer-service/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'TransferServiceList',
  components: {
    TransferService
  },
  mixins: [staticBlockMixin],
  props: {
    fullImage: {
      type: Boolean,
      required: false,
      default: false
    },
    showDivider: {
      type: Boolean,
      required: false,
      default: false
    }

  }
})
